import React from "react";
import styled from "styled-components";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Box from "react-raster";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import Container from "../Container";
import {
  Eyebrow,
  H2,
  Copy,
  AccentTitle,
  Blockquote,
  StyledList,
  richTextOptions,
} from "../Typography";

const QuoteContainer = styled.div`
  padding-left: 30px;
  @media (${({ theme }) => theme.mq.xl}) {
    padding-left: 0;
    max-width: 600px;
  }
`;

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function Partnership({
  quote,
  description,
  logo,
  eyebrow,
  title,
  richText,
  hasBottomMargin,
  hasTopMargin,
}) {
  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        <Box cols={[6, 12, 6]}>
          {eyebrow && <Eyebrow colour="purple">{eyebrow}</Eyebrow>}
          <H2>{title}</H2>
        </Box>
        <Box cols={[6, 12, 6]} marginTop={[0.5, 0.5, 0.25]}>
          {logo && (
            <GatsbyImage image={getImage(logo)} alt={logo.description} />
          )}
        </Box>
        {quote || description ? (
          <Box cols={[6, 12, 6]} marginTop={[1, 1, 0]}>
            {description && (
              <Copy style={{ marginBottom: "30px" }}>{description}</Copy>
            )}
            {quote && (
              <QuoteContainer>
                <Blockquote>{quote.quote}</Blockquote>
                <AccentTitle>{quote.name}</AccentTitle>
                <Eyebrow colour="lightGrey">
                  {quote.position}
                  {quote.company && `  — ${quote.company}`}
                </Eyebrow>
              </QuoteContainer>
            )}
          </Box>
        ) : null}
        {richText && (
          <Box cols={[6, 12, 6]} marginTop={[1, 1, 0]}>
            <StyledList>{renderRichText(richText, richTextOptions)}</StyledList>
          </Box>
        )}
      </Container>
    </FullWidthWrapper>
  );
}

export default Partnership;
